import { jsx as _jsx } from "react/jsx-runtime";
import { assetLightboxOpenedEvent, getLightboxMediaInfo, getLightboxMediaItems, } from '#pplx/frontend/apps/ask/asset-utils/mediaAssetInfo.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback, useLayoutEffect, useState } from 'react';
const MediaLightbox = Dynamic(async () => {
    const { MediaLightbox } = await import('#pplx/frontend/apps/ask/asset-utils/MediaLightbox.js');
    return { default: MediaLightbox };
});
export function useMediaLightbox({ reason, resetKey }) {
    const { track } = useInstrumentation();
    const [mediaLightbox, setMediaLightbox] = useState(null);
    const [mediaItems, setMediaItems] = useState([]);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const open = useCallback((media, gallery) => {
        const mediaInfo = getLightboxMediaInfo(media);
        if (!mediaInfo)
            return false;
        track(assetLightboxOpenedEvent(mediaInfo, reason));
        setMediaLightbox(mediaInfo);
        setMediaItems(getLightboxMediaItems(gallery ?? [media]));
        setIsLightboxOpen(true);
        return true;
    }, [reason, track]);
    const closeLightbox = useCallback(() => setIsLightboxOpen(false), []);
    useLayoutEffect(() => {
        closeLightbox();
    }, [closeLightbox, resetKey]);
    const lightboxElement = mediaLightbox ? (_jsx(MediaLightbox, { isOpen: isLightboxOpen, reason: reason, mediaLightbox: mediaLightbox, setMediaLightbox: setMediaLightbox, mediaItems: mediaItems, closeLightbox: closeLightbox })) : null;
    return { open, lightboxElement, closeLightbox, isLightboxOpen };
}
//# sourceMappingURL=useMediaLightbox.js.map